var tabsInit;

(function ($) {

	const selectors = {
		wrapper: '[data-tabs]',
		tabsWrapper: '[data-tabs-wrap]',
		links: '[data-tabs-link]',
		tabs: '[data-tabs-tab]',
		parent: '[data-tabs-link-parent]',
		parentItem: '> a'
	}

	tabsInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Tabs(el);
		})
	}

	class Tabs {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$tabLinks = $(selectors.links, this.$wrapper);
			this.$tabsWrapper = $(selectors.tabsWrapper, this.$wrapper);
			this.$tabs = $(selectors.tabs, this.$wrapper);

			this.animate = true;
			this.duration = 400;
			this.allowAllClosed = this.$wrapper.attr('data-allow-all-closed') !== undefined;

			this.bind();

		}
		bind() {
			const self = this;

			self.$tabLinks.click(this.onTabLinkClicked.bind(this));

			$(document).on('hp-plugins-loaded', () => {
				const $target_tab = this.$tabLinks.filter('.is-active').length ? this.$tabLinks.filter('.is-active').first() : this.$tabLinks.first();
				if (!this.allowAllClosed) self.switchTab($target_tab.attr('href'), false);
			});

		}

		onTabLinkClicked(e) {
			e.preventDefault();

			const $link = $(e.delegateTarget);
			this.switchTab($link.attr('href'));
		}

		switchTab(targetId, animate) {
			if (!targetId) return;
			if (targetId == '#') return;

			const self = this;
			const $targetTab = self.$tabs.filter(targetId).eq(0);
			if (animate === undefined) animate = self.animate;

			if ($targetTab.hasClass('is-active')) {

				if (this.allowAllClosed) {

					self.$tabLinks.removeClass('is-active').closest(selectors.parent).find(selectors.parentItem).removeClass('is-active');
					self.$tabs.removeClass('is-active');

					if (animate) {
						const $curTab = self.$tabs.filter(':visible');

						$curTab.stop().animate({ 'height': 0 }, self.duration, function () {
							$(this).hide().css({ 'height': '' });
						});


					}
					else {
						self.$tabs.hide();
					}
				}

				return;

			}

			$(document).trigger('switching-to-tab', { targetId: targetId, $targetTab: $targetTab });

			self.$tabLinks.removeClass('is-active').closest(selectors.parent).removeClass('is-active').find(selectors.parentItem).removeClass('is-active');
			self.$tabLinks.filter((i, el) => { return $(el).attr('href') === targetId }).addClass('is-active').closest(selectors.parent).addClass('is-active').find(selectors.parentItem).addClass('is-active')

			// Remove data-disabled attribute from the next tab link
			const currentIndex = self.$tabLinks.index(self.$tabLinks.filter((i, el) => { return $(el).attr('href') === targetId }));
			const $nextTabLink = self.$tabLinks.eq(currentIndex + 1);
			if ($nextTabLink.length) {
				$nextTabLink.removeAttr('data-disabled');
			}

			self.$tabs.removeClass('is-active');
			$targetTab.addClass('is-active');

			// Scroll to top of tab if it's out of view
			const tabOffset = self.$wrapper.offset().top;
			const windowScrollTop = $(window).scrollTop();
			const headerHeight = $('header').outerHeight() || 0; // Adjust if you have a fixed header

			if (tabOffset < windowScrollTop || tabOffset > (windowScrollTop + $(window).height())) {
				$('html, body').animate({
					scrollTop: tabOffset - headerHeight - 20 // 20px extra padding
				}, animate ? self.duration : 0);
			}

			if (animate) {

				const $curTab = self.$tabs.filter(':visible');
				const curHeight = $curTab.length ? $curTab.eq(0).outerHeight() : 0;

				self.$tabsWrapper.addClass('is-changing');

				$curTab.css('position', 'absolute');
				$targetTab.css({ 'opacity': 0, 'height': '' }).show();

				if ($targetTab.find('.slick-initialized').length && typeof $.fn.slick !== 'undefined') {
					$targetTab.find('.slick-initialized').slick('setPosition');
				}

				const newHeight = $targetTab.outerHeight();

				$curTab.stop().animate({ 'opacity': 0 }, self.duration, function () {
					$(this).hide().css({ 'position': '', opacity: '' });
				});

				$targetTab.css('height', curHeight).stop().animate({ 'height': newHeight, 'opacity': 1 }, self.duration, function () {
					$(this).css({ 'height': '', 'opacity': '' });
					self.$tabsWrapper.removeClass('is-changing');
				});

			}
			else {
				self.$tabs.hide();
				$targetTab.show();
			}



		}

	}

})(jQuery);


export default tabsInit;